(function () {
  function init(section) {
    if (section.dataset.brPathwaySystemReady === 'true') return;
    section.dataset.brPathwaySystemReady = 'true';

    var links = Array.prototype.slice.call(
      section.querySelectorAll('[data-br-pathway-system-link]')
    );
    var items = Array.prototype.slice.call(
      section.querySelectorAll('[data-br-pathway-system-item]')
    );

    if (!links.length || !items.length || !('IntersectionObserver' in window)) return;

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.brPathwaySystemTarget === id);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          });

        if (visible[0] && visible[0].target.id) {
          setActive(visible[0].target.id);
        }
      },
      {
        root: null,
        rootMargin: '-25% 0px -45% 0px',
        threshold: [0.2, 0.45, 0.7],
      }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initAll(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-br-pathway-system]')).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
